import { memo as Memo, useMemo, useEffect, useRef } from 'react';
import { gsap, Bounce } from 'gsap';

const Smile = Memo(({ happy, ...props }) => {
	//! Refs
	const mouthRef = useRef();

	//! Path Values
	const happyPath = useMemo(() => 'M57,49.7c-4.3,4.5-9.8,7.2-15.8,7.2c-6.2,0-11.9-2.9-16.2-7.7', []);
	const sadPath = useMemo(() => 'M57,56.3c-4.3-4.5-9.8-7.2-15.8-7.2c-6.2,0-11.9,2.9-16.2,7.7', []);

	useEffect(() => {
		gsap.to(mouthRef.current, 0.5, {
			morphSVG: {
				shape: happy ? happyPath : sadPath,
				type: 'linear',
			},
			ease: Bounce.easeOut,
		});
	}, [happy, mouthRef]);

	return (
		<svg
			className={`smile smile ${props.className || ''}`}
			viewBox='0 0 82 82'>
			<path
				d='M81,41A40,40,0,1,1,41,1,40,40,0,0,1,81,41Z'
				className={`st0`}
			/>
			<path
				id='happy'
				ref={mouthRef}
				className={`st0`}
				d='M57,49.7c-4.3,4.5-9.8,7.2-15.8,7.2c-6.2,0-11.9-2.9-16.2-7.7'
			/>
			<path
				id='sad'
				className={`mouth st1`}
				d='M57,56.3c-4.3-4.5-9.8-7.2-15.8-7.2c-6.2,0-11.9,2.9-16.2,7.7'
			/>

			<path d='M29,31a2,2,0,0,1-1.41-3.41,2,2,0,0,1,2.82,0A2,2,0,0,1,29,31Z' />
			<path d='M53,31a1.72,1.72,0,0,1-.39,0,1.82,1.82,0,0,1-.38-.11,2.27,2.27,0,0,1-.34-.19,2.16,2.16,0,0,1-.55-.55,1.63,1.63,0,0,1-.19-.34,1.82,1.82,0,0,1-.11-.38,1.92,1.92,0,0,1,0-.78,1.58,1.58,0,0,1,.11-.37,1.48,1.48,0,0,1,.19-.35,2.16,2.16,0,0,1,.55-.55,2.27,2.27,0,0,1,.34-.19,1.82,1.82,0,0,1,.38-.11,2,2,0,0,1,.78,0,1.58,1.58,0,0,1,.37.11,2,2,0,0,1,.35.19,1.42,1.42,0,0,1,.3.25A2,2,0,0,1,55,29a1.72,1.72,0,0,1,0,.39,1.82,1.82,0,0,1-.11.38,2.27,2.27,0,0,1-.19.34,2.16,2.16,0,0,1-.55.55,2,2,0,0,1-.35.19,1.58,1.58,0,0,1-.37.11A1.72,1.72,0,0,1,53,31Z' />
		</svg>
	);
});

export default Smile;
